import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from '../../../app/api/api';
import MealItem from '../../../app/data/models/mealItem';

export interface MealItemListState {
  mealItems: MealItem[];
  status: string;
}

const initialState: MealItemListState = {
  mealItems: [],
  status: 'idle',
};

export const fetchMealItemListAsync = createAsyncThunk<MealItem[], string>(
  'mealItems/list',
  async (restaurantId, thunkApi) => {
    try {
      return await api.MealItem.list(`${restaurantId}`);
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      return thunkApi.rejectWithValue({ error: error.data });
    }
  }
);

export const mealItemListSlice = createSlice({
  name: 'mealItems',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchMealItemListAsync.pending, (state) => {
      state.status = 'pendingFetchMealItems';
    });
    builder.addCase(fetchMealItemListAsync.fulfilled, (state, action) => {
      state.mealItems = action.payload;
      state.status = 'idle';
    });
    builder.addCase(fetchMealItemListAsync.rejected, (state) => {
      state.status = 'idle';
    });
  },
});
